import { Button, Typography } from 'antd';
import { useTitle } from 'hooks';

import { omniChatMessages, sidebarMenuMessages } from 'messages';
import { PageHeader } from 'components/common';
import { OmniHistoriesLeadManageProvider, TabChatManagementKeys, useOmniHistoriesLeadManageContext } from 'contexts';
import { twMerge } from 'tailwind-merge';
import { ROUTE } from 'routes/constants';

import AssignManagementTab from './AssignManagementTab';
import { LeftIcon } from 'assets';
import { Link } from 'react-router-dom';
import OngoingChatManagementTab from './OngoingChatManagementTab';
import ChatHistoriesTab from './ChatHistoriesTab';

export type SingleAgentMapSingleStatusesType = {
  extension: string;
  agentName: string;
  state: string;
  backgroundColor: string;
  iconColor: string;
  textColor: string;
  startTime: number;
};

export type chartDataType = {
  extensionId: string;
  statusName: string;
};

/**
 * Component
 */
const ChatManagementContent = () => {
  useTitle(sidebarMenuMessages.chatManagement);

  const { tab, setTab } = useOmniHistoriesLeadManageContext();

  return (
    <div className='flex min-h-[calc(100vh-100px)] pl-4 pr-1'>
      <PageHeader className='flex items-center gap-4'>
        <Link to={ROUTE.ACCESS_DTV_MANAGEMENT}>
          <Button shape='circle' icon={<LeftIcon />} />
        </Link>

        <Typography.Title className='text-header-label mb-0'>{sidebarMenuMessages.chatManagement}</Typography.Title>
      </PageHeader>
      <div className='flex flex-1 flex-col rounded-xl border border-lineColor1 bg-colorBgContainer'>
        <div className='flex h-[76px] items-center justify-center gap-2 border-b border-lineColor1'>
          <div
            onClick={() => setTab(TabChatManagementKeys.ASSIGN)}
            className={twMerge(
              'flex h-9 cursor-pointer items-center gap-2 rounded-full border px-4',
              tab === TabChatManagementKeys.ASSIGN && 'bg-backgroundColor3 text-white'
            )}
          >
            <span className='text-sm font-semibold'>{omniChatMessages.assign}</span>
          </div>
          <div
            onClick={() => setTab(TabChatManagementKeys.ONGOING)}
            className={twMerge(
              'flex h-9 cursor-pointer items-center gap-2 rounded-full border px-4',
              tab === TabChatManagementKeys.ONGOING && 'bg-backgroundColor3 text-white'
            )}
          >
            <span className='text-sm font-semibold'>{omniChatMessages.ongoingChat}</span>
          </div>

          <div
            onClick={() => setTab(TabChatManagementKeys.HISTORY)}
            className={twMerge(
              'flex h-9 cursor-pointer items-center gap-2 rounded-full border px-4',
              tab === TabChatManagementKeys.HISTORY && 'bg-backgroundColor3 text-white'
            )}
          >
            <span className='text-sm font-semibold'>{omniChatMessages.historyChat}</span>
          </div>
        </div>
        <div className='flex-1'>
          {tab === TabChatManagementKeys.ASSIGN && <AssignManagementTab />}
          {tab === TabChatManagementKeys.ONGOING && <OngoingChatManagementTab />}
          {tab === TabChatManagementKeys.HISTORY && <ChatHistoriesTab />}
        </div>
      </div>
    </div>
  );
};
const ChatManagement = () => {
  return (
    <OmniHistoriesLeadManageProvider>
      <ChatManagementContent />
    </OmniHistoriesLeadManageProvider>
  );
};

export default ChatManagement;
